export const FileHelper = {
  /**
   * Возвращает полный путь к файлу ресурса
   */
  readResourceImage(_: any, fileName: string): string {
    const imgPath = '/img'
    return imgPath + fileName
  },
}

export default FileHelper
